<template>
  <div>
    <!-- create dialog -->
    <dialogTemplate
      :openDialog="isOpen"
      :widthDialog="'450px'"
      :classDialog="'createDialog'"
      :offsetTop="''"
      @closeDialog="$emit('closeDialog')"
    >
      <template #body>
        <h3 class="dialogTitle margin-left-0">Thông tin hỗ trợ</h3>
        <div class="content-support-info">
          <div class="item-content-support-info">
            <div><i class="fas fa-user color__link margin-right-10"></i>Họ tên</div>
            <div>Nguyễn Minh An</div>
          </div>
          <div class="item-content-support-info">
            <div><i class="fas fa-phone color__link margin-right-10"></i>Số điện thoại</div>
            <div>0965240637</div>
          </div>
          <div class="item-content-support-info">
            <div><i class="fas fa-envelope color__link margin-right-10"></i>Email</div>
            <a href="mailto:hr@intrust.com.vn">annm@intrust.com.vn</a>
          </div>
          <div class="item-content-support-info">
            <div><i class="fab fa-telegram color__link margin-right-10"></i>Telegram</div>
            <a href="https://t.me/minhan1410">@minhan1410</a>
          </div>
        </div>
      </template>
    </dialogTemplate>
  </div>
</template>

<script>
export default {
  name: "dialog-support-info",
  props: ["isOpen"],
  components: {
    dialogTemplate: () => import("../../views/common/custom-dialog.vue"),
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/header/support.vue